// extracted by mini-css-extract-plugin
export var icon = "_bq-3";
export var subtitle = "_bq-2";
export var title = "_bq-1";
export var value = "_bq-0";